import React from 'react';
import { useParams } from 'react-router-dom';

export const AudienceView = () => {
  const { audienceId } = useParams<{ audienceId: string }>();
  // fetch/check for audience

  return <div className="CampaignView">Viewing audience: {audienceId}</div>;
};
